import { RouterState } from 'mobx-state-router';

const unauthorizedRoute = new RouterState('unauthorized');

export { unauthorizedRoute };



// WEBPACK FOOTER //
// ./src/core/utils/router/commonRoutes.js